import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import {TeamMembersTeam} from 'orgs/__generated/TeamMembersTeam';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {BenchlingAppsTable} from './MembersTable';
import {Member, MemberInfo} from './OrganizationConstants';

export default function TeamBenchlingAppMembersTab({
  team,
  teamBenchlingAppMembers,
  isCurrentUserMember,
  userIdToMemberInfo,
}: {
  team: TeamMembersTeam;
  teamBenchlingAppMembers?: Array<Member>;
  isCurrentUserMember: boolean;
  userIdToMemberInfo: {[userId: string]: MemberInfo} | null;
}): JSX.Element {
  if (!teamBenchlingAppMembers || !userIdToMemberInfo) {
    return <CenteredHorizontalThrobber />;
  }

  if (teamBenchlingAppMembers.length === 0) {
    return <div>No apps yet.</div>;
  }

  const canManageRoles = team.permissions.canManageRoles ?? false;
  return (
    <BenchlingAppsTable
      groupId={team.id}
      groupType={ModelTypeConstants.TEAM}
      canManageRoles={canManageRoles}
      members={teamBenchlingAppMembers}
      shouldShowMemberInfo={isCurrentUserMember || canManageRoles}
      userIdToMemberInfo={userIdToMemberInfo}
    />
  );
}
